import { ConfirmUnsaved } from "components/ConfirmDialog/ConfirmUnsaved";
import { HookFormDebug } from "components/FormDebug/HookFormDebug";
import { EditFormFooter } from "components/Forms/EditFormFooter";
import { SlidingPanel } from "components/SlidingPanel/SlidingPanel";
import { useTranslations } from "providers";
import React from "react";

import { useEditBoardConfiguration } from "../useEditBoardConfiguration";
import { EditBoardConfigurationForm } from "./EditBoardConfigurationForm";

export const EditBoardConfigurationPanel: React.FC = () => {
  const i18n = useTranslations();
  const {
    isDirty,
    isValid,
    isSubmitting,
    isSubmittable,
    confirmUnsaved,
    setConfirmUnsaved,
    getPatch,
    handleSave,
    handleClose,
    form,
  } = useEditBoardConfiguration();

  const saveButtonDisabled = !isDirty || !isValid;

  return (
    <>
      <SlidingPanel
        isOpen={true}
        onCancel={() => handleClose(true)}
        onClose={() => handleClose()}
        onSave={() => handleSave()}
        saveButtonDisabled={saveButtonDisabled}
        isSubmitting={isSubmitting}
        header={<h1>{i18n.BoardSettings_MeetingDefaults}</h1>}
        debugContent={
          <HookFormDebug
            watch={() => getPatch(form.watch())}
            formState={form.formState}
            isSubmitting={isSubmitting}
            isSubmittable={isSubmittable}
          />
        }
        footer={
          <EditFormFooter
            onCancel={() => handleClose(true)}
            onSubmit={() => handleSave()}
            isSubmitting={isSubmitting}
            isDirty={isDirty}
          />
        }
      >
        <EditBoardConfigurationForm />
      </SlidingPanel>

      <ConfirmUnsaved
        onAccept={() => handleClose(true)}
        isOpen={confirmUnsaved}
        setIsOpen={setConfirmUnsaved}
        onCancel={() => setConfirmUnsaved(false)}
      />
    </>
  );
};
